import Images from '../../Components/Vimdt/Images/Images';
import useRowCount from '../../Utils/Vimdt/useRowCount';

function ImagesPage() {
	return <Images rowCount={useRowCount()} />;
}

export default ImagesPage;
